"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Split = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const h = React.createElement;
const className = (0, nano_theme_1.rule)({
    d: 'flex',
    justifyContent: 'space-between',
    w: '100%',
});
const alignMap = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
    stretch: 'stretch',
    baseline: 'baseline',
};
const Split = ({ as = 'div', align, style, children, ...rest }) => {
    rest.className = (rest.className || '') + className;
    if (align)
        style = { alignItems: alignMap[align], ...style };
    if (style)
        rest.style = style;
    return h(as, rest, children[0], children[1]);
};
exports.Split = Split;
